// import React from "react";

// export default function Tab({ name, type, data, updateDataSource, updateSelectedTab, selectedTab, dataArrayName }) {
//     function click() {
//         updateDataSource(dataArrayName)
//         updateSelectedTab(name)
//     }
//     return (
//         <div className={selectedTab === name ? 'TabOn' : 'Tab'} onClick={click}>
//             <span className="type1">{data}</span> <span className="type"> {type}</span>
//             <div> {name}</div>
//         </div>
//     );
// }
import React from "react";

export default function Tab({
  tabName,
  last,
  tabUnit,
  tabIndex,
  updateDataSource,
  updateSelectedTab,
  selectedTab,
  dataArrayName,
}) {
  let noData = dataArrayName.length < 1;
  function click() {
    // updateDataSource(dataArrayName);
    updateSelectedTab(tabIndex);
  }
  // console.log("tabName", tabName, "last", last);
  return (
    <div className={selectedTab === tabName ? `TabOn ${"TabOn" + tabUnit}` : `Tab ${"Tab" + tabUnit}`} onClick={!noData ? click : () => console.log('no data')}>
      <div className={"line" + tabUnit}>
        <div className="InText">
          <div>
            {noData ? '--' : last}
          </div>
          {<div style={{ fontSize: "1rem" }}>{tabUnit}</div>}
        </div>
        {/* <div className="tabMS"> {tabMS}</div> */}
      </div>
      {/* <div className="tabName">{tabName}</div> */}
    </div>
  );
}
